import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StreappEvent } from '../../../../models/streappevent.model';

@Component({
    selector: 'app-similar-events-dialog',
    templateUrl: './similar-events-dialog.component.html',
    styleUrls: ['./similar-events-dialog.component.scss'],
    standalone: false
})
export class SimilarEventsDialogComponent {
  constructor(public dialogRef: MatDialogRef<SimilarEventsDialogComponent>,
  @Inject(MAT_DIALOG_DATA) public data: StreappEvent[] ) { }

  closeAndCancel(): void {
    this.dialogRef.close({ result: 'cancel', event: null });
  }

  closeWithoutLinking(): void {
    this.dialogRef.close({ result: 'new', event: null });
  }

  closeWithLinking(event: StreappEvent): void {
    this.dialogRef.close({ result: 'link', event: event });
  }
}
